import { FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  return (
    <>
          <footer className="footer">
            <div className="container footer__inner">
              <div className="footer__brand">
                <span className="footer__logo">🌾 Celestial Grains</span>
                <p>Alberta's finest pulses — bridging prairies to global plates.</p>
              </div>
    
              <div className="footer__nav">
                <strong>Navigate</strong>
                {["Products", "About", "Exports", "FAQ", "Contact"].map((l) => (
                  <a key={l} href={`#${l.toLowerCase()}`}>
                    {l}
                  </a>
                ))}
              </div>
    
              <div className="footer__nav">
                <strong>Products</strong>
                {[
                  "Red Lentils",
                  "Green Lentils",
                  "Yellow Peas",
                  "Chickpeas",
                  "Black Beans",
                ].map((p) => (
                  <a key={p} href="#products">
                    {p}
                  </a>
                ))}
              </div>
    
              <div className="footer__contact">
                <strong>Find Us</strong>
                <span>Calgary, Alberta, Canada</span>
                <span>contact@celestialgrains.ca</span>
                <span>+1 (403) 497-9816</span>
              </div>
            </div>
    
            <div className="footer__bottom">
              <span>© 2025 Celestial Grains. All rights reserved.</span>
              <span>Built with ❤️ in Calgary</span>
            </div>
          </footer>
    
          {/* Floating WhatsApp Button */}
          <a
            href="https://wa.me/14034979816?text=Hello%20Celestial%20Grains,%20I%20would%20like%20to%20enquire%20about%20your%20pulse%20export%20products."
            className="whatsapp-float"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp"
          >
            <FaWhatsapp />
          </a>
        </>
  );
};

export default Footer;